import { fetchdata } from 'apis/FetchData';
import { handle420 } from 'apis/HandleError';
import { apiConfig } from 'config';

export function fetchAlarms(deviceIDs, alarmNames, severityList, alarmStates, from, to, size, next, sort) {
  let postBody = {
    ...(deviceIDs && { device: deviceIDs }),
    ...(alarmNames && { name: alarmNames }),
    ...(severityList && { severity: severityList }),
    ...(alarmStates && { state: alarmStates }),
    ...(from && { from: from }),
    ...(to && { to: to }),
    ...(size && { size: size }),
    ...(next && { next: next }),
    ...(sort && { sort: sort })
  };

  return fetchdata(apiConfig.fmServiceAlarms, { method: 'POST', body: JSON.stringify(postBody) }).catch((e) => {
    console.log('fetch data error = ' + e.message);
    switch (e.message) {
      case '420':
        handle420();
        break;
      default:
        throw e.message;
    }
  });
}
